import type { BriefWorkout, CalendarWorkout, WorkoutDetail } from '../services/api';

export function calendarWorkoutState(workout: BriefWorkout | CalendarWorkout | WorkoutDetail, today: string) {
  const name = `${workout.workout_type?.english_name ?? ''} ${workout.workout_type?.name ?? ''}`.toLowerCase();
  const type = workout.workout_type;
  const rest = Number(type && 'id' in type ? type.id : undefined) === 7 || /day[ -]?off|rest day|روز استراحت/.test(name);
  const done = !rest && [workout.total_time, workout.distance, workout.tss_actual].some(value => value != null && Number.isFinite(Number(value)) && Number(value) > 0);
  const missed = !rest && !done && !!workout.workout_day && workout.workout_day.slice(0, 10) < today;
  return { rest, done, missed, canShare: done };
}

export function localCalendarDay(date = new Date()): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
